<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import {
    Button,   
    Col,
    FormGroup,
    Icon,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
  } from "sveltestrap";
  import { v4 as v4uuid } from "uuid";
  import type { Fn } from "../global";
  import { thirdsService } from "../services";
  import type { Third } from "../Model/Third";
  import ThirdFormForModal from "./thirdFormForModal.svelte";
  import AddThirdList from "./AddThirdList.svelte";

  const dispatch = createEventDispatcher();

  let size = "lg";
  let third: Third;

  export let open = false;
  export let type = null;
  export let thirdId = null;
  export let toggle: Fn = undefined;

  let newThird = false;
  let uuidThird;

  $: load(thirdId);

  async function load(thirdId) {
    if (thirdId) {
      third = await thirdsService.findOne(thirdId);
    }
  }

  async function createThird() {
    newThird = true;
    uuidThird = v4uuid();
  }

  async function changeThird(third) {
    toggle();
    dispatch("changeThird", third);
    open = false;
  }

  function toggleThird() {
    newThird = !newThird;
  }

  async function loadThird(thirdId) {
    try {
      let newPerson = await thirdsService.findOne(thirdId);
      changeThird(newPerson);
    } catch (err) {}
  }
</script>

<Modal isOpen={open} {toggle} {size}>
  {#if !newThird}
    <ModalHeader {toggle}>Buscar Tercero</ModalHeader>
    <ModalBody>
      <AddThirdList on:changeThird={(event) => changeThird(event.detail)} />
    </ModalBody>
    <ModalFooter>
      <Button color="primary"    on:click={() => createThird()}>Crear Tercero</Button>
    </ModalFooter>
  {/if}

  {#if newThird}
    <ModalHeader
      toggle={() => {
        newThird = false;
      }}>Crear Tercero</ModalHeader
    >
    <ModalBody>
      <ThirdFormForModal
        thirdId={uuidThird}
        toggle={toggleThird}
        on:changeThird={(event) => loadThird(event.detail)}
      />
    </ModalBody>
  {/if}
</Modal>

<style>
</style>
